import { rest } from 'msw'
export default [
  /**
   * パスワードリセットメール送信
   */
  rest.post('/api/v2/send_reset_password_mail', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: 'ユーザ登録エラー',
          errorMessageDetail: '既に登録済みのメールアドレスです',
        },
        userId: 1,
        responseTime: 915148799,
      })
    )
  }),
  /**
   * ユーザー仮登録
   */
  rest.post('/api/v2/pre_regist_user', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: 'ユーザ登録エラー',
          errorMessageDetail: '既に登録済みのメールアドレスです',
        },
        status: 1,
        responseTime: 915148799,
      })
    )
  }),
  /**
   * パスワード再設定
   */
  rest.post('/api/v2/reset_password', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 10,
          errorMessage: 'ユーザ登録エラー',
          errorMessageDetail: '既に登録済みのメールアドレスです',
        },
        status: 1,
        responseTime: 915148799,
      })
    )
  }),
  /**
   * ユーザー本登録
   */
  rest.post('/api/v2/regist_user', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: 'ユーザ登録エラー',
          errorMessageDetail: '既に登録済みのメールアドレスです',
        },
        status: 1,
        responseTime: 915148799,
      })
    )
  }),
  /**
   * パスワード変更
   */
  rest.post('/api/v2/modify_password', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: 'ユーザ登録エラー',
          errorMessageDetail: '既に登録済みのメールアドレスです',
        },
        userId: 1,
        responseTime: 915148799,
      })
    )
  }),
  /**
   * ユーザーメールアドレス変更
   */
  rest.post('/api/v2/modify_mailaddress', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: 'ユーザ登録エラー',
          errorMessageDetail: '既に登録済みのメールアドレスです',
        },
        userId: 1,
        responseTime: 915148799,
      })
    )
  }),
  /**
   * アドレス変更メール送信
   */
  rest.post('/api/v2/send_modify_address_mail', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 10,
          errorMessage: 'ユーザ登録エラー',
          errorMessageDetail: '既に登録済みのメールアドレスです',
        },
        userId: 1,
        responseTime: 915148799,
      })
    )
  }),
  /**
   * ユーザー情報
   */
  rest.post('/api/v2/get_user_info', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          user: {
            appNo: '7418-8525-0638',
            impressionKey: 'e785dc3d943d477c97673bc47d2b4754',
            hasMailAddress: 0,
          },
          chains: [
            {
              chainId: 5,
              chainName: 'コープさっぽろ',
              isRegist: 1,
              displayCardNo: 'xxxxxxxx-x2222',
            },
            {
              chainId: 5,
              chainName: 'コープさっぽろ',
              isRegist: 1,
              displayCardNo: 'xxxxxxxx-x3333',
            },
            {
              chainId: 5,
              chainName: 'コープさっぽろ',
              isRegist: 1,
              displayCardNo: 'xxxxxxxx-x1111',
            },
          ],
          accounts: [],
          responseTime: 1583204868,
        },
      })
    )
  }),
]
